/* eslint-disable no-param-reassign */
import { typeOf } from './object';

export const uniqueArray = (arr, id = 'id') => arr.filter((v, i, a) => a.findIndex((v2) => (v2[id] === v[id])) === i);

export const groupBy = (nodes, property) => {
  const groupedMap = nodes.reduce(
    (entryMap, e) => entryMap.set(e[property], [...entryMap.get(e[property]) || [], e]),
    new Map(),
  );

  return [...groupedMap];
};

const topLevel = (data, key) => data.filter((node) => !node[key]);

const traverse = (data, parentId, key) => {
  const children = data.filter((each) => each[key] === parentId);
  children.forEach((child) => {
    child.rows = traverse(data, child.id, key);
  });
  return children;
};

export const recursiveGroupBy = (data, key) => topLevel(data, key).map((each) => {
  each.rows = traverse(data, each.id, key);
  return each;
});

export const addCountryInfo = (countries) => (item) => {
  const countryInfo = countries.find(
    (country) => country.iso === (item.institutionCountry || item.country),
  );

  return ({ ...item, countryInfo });
};

export const isEmpty = (value) => {
  const typeOfValue = typeOf(value);

  const valueMap = {
    array: value?.length === 0,
    string: value === '',
  };

  return valueMap[typeOfValue] || !value;
};

export const mergeUnique = (items, property = 'id') => {
  const map = new Map();

  items.forEach((item) => {
    map.set(item[property], item);
  });

  return Array.from(map.values());
};
